export const PSN = Object.freeze({
  R4FRONT: 'R4 front',
  R4FRONTSIDE: 'R4 front side',
  R4REARSIDE: 'R4 rear side',
  R4REAR: 'R4 rear',
  R4BULL: 'R4 bulls eye',
  R3FRONT: 'R2-3 front',
  R3FRONTSIDE: 'R2-3 front side',
  R3REARSIDE: 'R2-3 rear side',
  R3REAR: 'R2-3 rear',
  R3BULL: 'R2-3 bulls eye',
  R1FRONT: 'R1-2 front',
  R1FRONTSIDE: 'R1-2 front side',
  R1REARSIDE: 'R1-2 rear side',
  R1REAR: 'R1-2 rear',
  R1BULL: 'R1-2 bulls eye',
  STRSBULL: 'stressed bulls-eye',
  STRSFRONT: 'stressed front',
  STRSFRONTSIDE: 'stressed front side',
  STRSREARSIDE: 'stressed rear side',
  STRSREAR: 'stressed rear',
} as const);

export type Position = (typeof PSN)[keyof typeof PSN];

export const MVRS = Object.freeze({
  STRAIGHT1: 'straight 1',
  STRAIGHT1BLUE: 'blue straight 1',
  STRAIGHT2: 'straight 2',
  STRAIGHT2BLUE: 'blue straight 2',
  STRAIGHT3: 'straight 3',
  STRAIGHT3BLUE: 'blue straight 3',
  STRAIGHT4: 'straight 4',
  STRAIGHT4BLUE: 'blue straight 4',
  STRAIGHT5: 'straight 5',
  STRAIGHT5BLUE: 'blue straight 5',
  BANK1: 'bank 1',
  BANK1OPPOSITE: 'opposite bank 1',
  BANK1BLUE: 'blue bank 1',
  BANK1BLUEOPPOSITE: 'opposite blue bank 1',
  BANK2: 'bank 2',
  BANK2OPPOSITE: 'opposite bank 2',
  BANK2BLUE: 'blue bank 2',
  BANK2BLUEOPPOSITE: 'oppposite blue bank 2',
  BANK3: 'bank 3',
  BANK3OPPOSITE: 'opposite bank 3',
  BANK3RED: 'red bank 3',
  TURN1: 'turn 1',
  TURN1RED: 'turn 1 red',
  TURN2: 'turn 2',
  TURN2RED: 'red turn 2',
  TURN2BLUE: 'blue turn 2',
  TURN2BLUEOPPOSITE: 'opposite blue turn 2',
  TURN3: 'turn 3',
  TURN2OPPOSITE: 'opposite turn 2',
  TURN3OPPOSITE: 'opposite turn 3',
  SEGNOR3RED: 'segnor 3',
  SEGNOR3REDOPPOSITE: 'opposite segnor 3',
  TALLON3RED: 'tallon 3',
  TALLON3REDOPPOSITE: 'opposite tallon 3',
  KOIOGRAN3RED: 'red koiogran 3',
  KOIOGRAN4: 'koiogran 4',
  KOIOGRAN4RED: 'red koiogran 4',
  KOIOGRAN5RED: 'red koiogran 5',
  STATIONARYRED: 'stationary',
  REVERSESTRAIGHT1RED: 'reverse straight 1',
  REVERSEBANK1RED: 'reverse bank 1',
  REVERSEBANK2RED: 'reverse bank 2',
} as const);

export type Maneuver = (typeof MVRS)[keyof typeof MVRS];

export type ManeuverTuple = readonly [Maneuver, Maneuver, Maneuver, Maneuver, Maneuver, Maneuver];
